import React from 'react';

export default function CutsHeader({
  searchTerm,
  setSearchTerm,
  isLoggedIn,
  hasSavedCuts,
  favoritesOnly,
  setFavoritesOnly,
  children
}) {
  const showFavorites = isLoggedIn && hasSavedCuts;
  const favoritesLabel = favoritesOnly ? 'Show all cuts' : 'Show favorites';
  return (
    <section className="section cuts-hero">
      <div className="container">
        <div className="cuts-hero__intro">
          <span className="cuts-hero__eyebrow">Beef Cuts</span>
          <h1 className="cuts-hero__title">A Guide to Beef Cuts</h1>
        </div>

        <div className="cuts-hero__layout">
          <div className="cuts-hero__cards">
            <div className="cuts-hero__card">
              <h3 className="cuts-hero__card-title">
                Explore by Primal{' '}
                <span
                  className="cuts-hero__card-arrow"
                  aria-hidden="true"
                ></span>
              </h3>
              <p>Select a primal cut to explore the cuts within it.</p>
            </div>

            <div className="cuts-hero__card">
              <h3 className="cuts-hero__card-title">Find a Cut</h3>
              <p>Search by cut name.</p>
              <div
                className={`cuts-hero__search-row${
                  showFavorites ? ' cuts-hero__search-row--with-favorites' : ''
                }`}
              >
                <form
                  className="cuts-hero__search"
                  role="search"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <input
                    type="text"
                    className="cuts-hero__search-input"
                    placeholder="Ribeye, Brisket, Flank..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    aria-label="Search cuts by name"
                  />
                  <button
                    type="submit"
                    className="cuts-hero__search-btn"
                    aria-label="Search"
                  >
                    <span
                      className="cuts-hero__search-icon"
                      aria-hidden="true"
                    ></span>
                  </button>
                </form>

                {showFavorites && (
                  <button
                    type="button"
                    className="cuts-hero__fav-btn"
                    aria-pressed={favoritesOnly}
                    aria-label={favoritesLabel}
                    data-tooltip={favoritesLabel}
                    onClick={() => setFavoritesOnly((prev) => !prev)}
                  >
                    <svg
                      className="cuts-hero__fav-icon"
                      viewBox="0 0 17.46 16"
                      aria-hidden="true"
                    >
                      <path
                        fill="currentColor"
                        d="M8.73,2.36C6.44-1.57,0-.42,0,4.5c0,3.39,4.05,6.86,8.73,11.5,4.68-4.64,8.73-8.11,8.73-11.5,0-4.94-6.45-6.04-8.73-2.14"
                      />
                    </svg>
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="cuts-hero__graphic">{children}</div>
        </div>
      </div>
    </section>
  );
}
